<template>
  <b-button
    variant="primary"
    @click="refreshTable"
    class="d-flex align-items-center justify-content-center"
  >
    <feather-icon icon="RefreshCwIcon" />
  </b-button>
</template>
<script>
import { BButton } from "bootstrap-vue";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  components: {
    BButton,
  },
  props: {
    fetchList: {
      type: Function,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { t } = useI18nUtils();

    const refreshTable = () => {
      props.fetchList();
    };

    return {
      refreshTable,
    };
  },
};
</script>
